import { FC, PropsWithChildren, ReactNode } from 'react';
import { User } from '@services';
import { useLoggedinUser } from '@hooks';

export interface IGuardedRenderProps {
	canRender: (user: User) => boolean;
	fallback?: ReactNode;
}

export const GuardedRender: FC<PropsWithChildren<IGuardedRenderProps>> = ({ canRender, fallback, children }) => {
	const user = useLoggedinUser();
	return user && canRender(user) ? <>{children}</> : <>{fallback}</>;
};
